"use client";
import NotFoundComponent from "@/components/layout/notFound";

export default function NotFound() {
  return <NotFoundComponent />;
}
